var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.opened)?_c('section',{directives:[{name:"move-to-body",rawName:"v-move-to-body"}],class:['ds-dialog', { 'ds-dialog-usual': _vm.usualModal }],style:(_vm.dialogStyleObject),attrs:{"id":_vm.backdropId}},[_c('div',{class:[
      'ds-dialog-backdrop',
      { 'ds-dialog-datepicker-backdrop': _vm.datepickerContainer }
    ],style:({
      'opacity': _vm.backdropOpacity,
      'background-color': _vm.backgroundColor
    }),on:{"click":function($event){$event.stopPropagation();return _vm.backdropClick()},"keydown":function (e) { return _vm.escapePress(e); }}}),_c('div',{class:[
      'ds-dialog-content',
      {
        'ds-border-content': _vm.borderColor,
        'ds-full-screen-content': _vm.fullScreen,
        'ds-full-screen-active-content': _vm.fullScreenActive,
        'ds-full-width': _vm.contentFullWidth,
        'ds-dialog-datepicker-container': _vm.datepickerContainer
      }
    ],style:({ borderColor: _vm.borderColor, minHeight: _vm.minHeight, minWidth: _vm.minWidth, overflowY: _vm.overflowY }),attrs:{"id":_vm.idContent}},[_c('div',{class:['ds-dialog-wrapper', { 'ds-full-width': _vm.contentFullWidth }]},[_vm._t("default")],2),(_vm.enableLoader)?_c('Loader',{attrs:{"target":_vm.idContent},model:{value:(_vm.enableLoader),callback:function ($$v) {_vm.enableLoader=$$v},expression:"enableLoader"}}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }